import { useQuery } from "@tanstack/react-query";
import { getFeatureCatalog } from "../Api/featureCatalog";

export const useFeatureCatalog = () => {
  return useQuery({
    queryKey: ["featureCatalog"],
    queryFn: getFeatureCatalog,
    // The catalog only changes with a deploy.
    staleTime: Infinity,
  });
};
